import React, { useContext, useEffect, useState } from 'react';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputTextSimple from '../../../MySections/DTechComps/InputTextSimple';
import DatePick from '../../../MySections/DTechComps/DatePick';
import DropNumbersSelection from '../../../MySections/DTechComps/DropNumbersSelection';
import DropHouresSelection from '../../../MySections/DTechComps/DropHouresSelection';
import MyTextArea from '../../../MySections/TextEditor/MyTextArea';
import utilsTblOrders from '../../../../MyConns/_Utils/utilsTblOrders';
import MyDateTime from '../../../MySections/TimeSections/MyDateTime';
import TblOrderStatuselect from './TblOrderStatuselect';
import InputSet from '../../../MySections/PopUps/InputSet';
import { WaitingToApprovContext } from '../../../MyContexts/WaitingToApprov_Context';

const ShowTableOrder = (props) => {

    const [wToImpto, setWToImpto, checkIfItemExistsAndStatus] = useContext(WaitingToApprovContext);


    const [thePopUp, setThePopUp] = useState("");
    const [err, setErr] = useState(false);
    const [updaterName, setUpdaterName] = useState("");
    const [clientName, setClientName] = useState("");
    const [clientPhone, setClientPhone] = useState("");
    const [dinners, setDinners] = useState("");
    const [timeToCome, setTimeToCome] = useState("");
    const [dateToCome, setDateToCome] = useState();
    const [orderStatus, setOrderStatus] = useState("");
    const [remarks, setRemarks] = useState("");
    const [ordererName, setOrdererName] = useState("");
    const [tblOrderNum, setTblOrderNum] = useState("");

    const [ordrApprove, setOrdrApprove] = useState(false);
    const [theDispTableOrder, setTheDispTableOrder] = useState({});


    useEffect(() => {
        getTheTableOrder();
    }, [])

    const getTheTableOrder = async () => {
        let thord = await utilsTblOrders.getTableOrder(props.ordId);

        setDinners(thord.dinners);
        setDateToCome(new Date(thord.dateToCome));
        setTimeToCome(thord.timeToCome);
        setClientName(thord.clientName);
        setClientPhone(thord.clientPhone);
        setOrdererName(thord.ordererName);
        setRemarks(thord.remarks);
        setOrderStatus(thord.status);
        setTblOrderNum(thord.tblOrderNum);
        setTheDispTableOrder(thord);
    }

    const saveMe = () => {

        if (updaterName == "") {
            setThePopUp(<InputSet
                Title={"עובד מעדכן"}
                ContentText={"מה שמך?"}
                inLabel=""
                okClick={(nam) => { setTheNameAndSaveMe(nam) }}
                cancelClick={() => setThePopUp()} />)
        }
        else { saveIt(updaterName) }

    };

    const setTheNameAndSaveMe = (nam) => {
        setUpdaterName(nam);
        saveIt(nam);
        setThePopUp()
    }

    const saveIt = async (updtrNam) => {


        let rep = "";
        if (dinners == null || dinners == "") { rep = " יש לציין מספר סועדים" }
        else if (timeToCome == null || timeToCome == "") { rep = " יש לציין שעת הגעה" }
        else if (dateToCome == null || dateToCome == "") { rep = " יש לציין תאריך הגעה" }
        else if (clientName == null || clientName == "") { rep = " יש לציין שם לקוח" }
        else if (clientPhone == null || clientPhone == "") { rep = " יש לציין טלפון לקוח" }


        if (rep == "") {
            // props.okClick(inputTxt);

            let objToUpdate = {
                dinners: dinners,
                timeToCome: timeToCome,
                dateToCome: dateToCome,
                clientName: clientName,
                clientPhone: clientPhone,
                status: orderStatus,
                remarks: remarks,
                ordererName: ordererName,
                lastUpdaterBy: updtrNam
            }

            let ordTbl = await utilsTblOrders.updateTableOrder(props.ordId, objToUpdate);

            checkIfItemExistsAndStatus({_id:ordTbl._id, status:orderStatus});

            setErr("ההזמנה עודכנה בהצלחה, מספר הזמנה: " + tblOrderNum);
            setOrdrApprove(true)

            // handleClose();
        }
        else {
            setErr(rep);
        }
    }


    const handleClose = () => {
        props.cancelClick();
    };

    return (
        <Dialog open={true} onClose={handleClose} className={"orderPlaceBlockDiag popupZINDEX"}>
            <DialogTitle>{props.Title}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {props.ContentText}
                </DialogContentText>
                <div className={"orderPlaceBlock"}>
                    <h3 className="centerText">הזמנת שולחן {theDispTableOrder.tblOrderNum}</h3>

                    <br />
                    <div className={"row"}>
                        <div className={"col-md-4 justify-content-center"}>
                            <DropNumbersSelection
                                lbl="סועדים"
                                Typ="text"
                                Css="inputsDropDownStyle"
                                Val={dinners}
                                placeholder="מספר סועדים"
                                settingFunc={(val) => setDinners(val)}
                                maxNumb={50}
                            />

                        </div>
                        <div className={"col-md-4 justify-content-center"}>
                            <DatePick
                                lbl="לתאריך"
                                settingFunc={(val) => setDateToCome(val)}
                                Css="inputsStyle pointing"
                                selectedDate={dateToCome}
                            />
                        </div>

                        <div className={"col-md-4 justify-content-center"}>
                            <DropHouresSelection
                                lbl="לשעה"
                                Typ="text"
                                Css="inputsDropDownStyle"
                                Val={timeToCome}
                                placeholder="לשעה"
                                settingFunc={(val) => setTimeToCome(val)}
                                fromHour={10}
                                toHour={23}
                            />

                        </div>
                    </div>
                    <br />
                    <div className={"row"}>
                        <div className={"col-md-4 justify-content-center"}>
                            <InputTextSimple
                                lbl=""
                                Typ="text"
                                Css="inputsStyle"
                                Val={clientName}
                                placeholder="שם הלקוח"
                                settingFunc={(val) => setClientName(val)}
                            />

                        </div>
                        <div className={"col-md-4 justify-content-center"}>
                            <InputTextSimple
                                lbl=""
                                Typ="text"
                                Css="inputsStyle"
                                Val={clientPhone}
                                placeholder="טלפון"
                                settingFunc={(val) => setClientPhone(val)}
                            />

                        </div>
                        <div className={"col-md-4 justify-content-center"}>
                            <TblOrderStatuselect inStyle={{
                                width: '205px', height: '30px', marginTop: '12px'
                            }}
                                orderStatus={orderStatus}
                                setOrderStatus={(statBack) => setOrderStatus(statBack)}
                            />

                        </div>
                    </div>

                    <div className={"row"}>
                        <div className={"col-md-12 justify-content-center"} >
                            <MyTextArea firstText={remarks}
                                saveEditorTxt={(content) => { setRemarks(content) }}
                                cssStyle={"inputsStyle"}
                                styl={{ width: "104%" }}
                                placeholder="הערות" />
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-md-12 justify-content-center"}>
                            <p><span className='bold'>במקור הוזמנה על ידי: </span><span>{theDispTableOrder.ordererName}</span></p>
                            <p><span className='bold'>מועד ההזמנה: </span><span>{MyDateTime.getDateAndTime(theDispTableOrder.dateCreated)}</span></p>
                            <p><span className='bold'>עדכון אחרון בוצע על ידי: </span><span>{theDispTableOrder.lastUpdaterBy}</span></p>
                            <p><span className='bold'>עדכון אחרון בוצע ב: </span><span>{MyDateTime.getDateAndTime(theDispTableOrder.lastUpdate)}</span></p>
                        </div>

                    </div>
                    <div className='fullRow' style={{ minHeight: '30px' }}>
                        {err ? <div style={{ color: 'red', fontWeight: 'bold', textAlign: 'center' }}>{err}</div> : <div></div>}
                    </div>
                   
                    {!ordrApprove ?
                        <div className={"btnstblOrdrs"}>
                            <button type="button" className="onLeft btn btn-danger" onClick={handleClose}>ביטול</button>
                            <button type="button" className="onLeft btn btn-dark spaceMargeLeftbig" onClick={() => saveMe()}>שמור</button>
                        </div>
                        :
                        <div className={"btnstblOrdrs"}>
                            <button type="button" className="onLeft btn btn-dark spaceMargeLeftbig" onClick={() => { props.ordrApproved() }}>סגור</button>
                        </div>
                    }
                </div>
                {thePopUp}

            </DialogContent>

        </Dialog >
    );
}

export default ShowTableOrder;